"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _CardActions = _interopRequireDefault(require("@material-ui/core/CardActions"));

var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _gatsby = require("gatsby");

var _DocTags = _interopRequireDefault(require("./DocTags"));

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var styles = function styles(theme) {
  return {
    card: {
      width: 410,
      margin: 4
    },
    media: {
      minHeight: 200,
      paddingTop: '56.25%',
      // 16:9
      objectFit: 'cover'
    },
    actions: {
      display: 'flex'
    },
    expand: (0, _defineProperty2.default)({
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      }),
      marginLeft: 'auto'
    }, theme.breakpoints.up('sm'), {
      marginRight: -8
    }),
    expandOpen: {
      transform: 'rotate(180deg)'
    },
    avatar: {
      backgroundColor: theme.palette.secondary.light
    },
    coverTitle: (0, _defineProperty2.default)({
      backgroundColor: theme.palette.primary.dark,
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      width: '100%',
      textAlign: 'center',
      margin: '0',
      minHeight: '230px'
    }, "alignItems", 'center')
  };
};

var _ref = _react.default.createElement(_Edit.default, null);

var _ref2 = _react.default.createElement(_Button.default, {
  size: "small",
  color: "primary"
}, "Read");

var _ref3 = _react.default.createElement(_ExpandMore.default, null);

var DocSummary =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DocSummary, _Component);

  function DocSummary(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DocSummary);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DocSummary).call(this, props));
    _this.state = {
      mobile: true,
      expanded: false
    };
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleExpandClick = _this.handleExpandClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(DocSummary, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      if (window.innerWidth >= 640) {
        this.setState({
          mobile: false
        });
      } else {
        this.setState({
          mobile: true
        });
      }
    }
  }, {
    key: "handleExpandClick",
    value: function handleExpandClick() {
      this.setState(function (state) {
        return {
          expanded: !state.expanded
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          docInfo = _this$props.docInfo,
          classes = _this$props.classes,
          config = _this$props.config;
      var path = docInfo.path,
          tags = docInfo.tags,
          category = docInfo.category,
          description = docInfo.description,
          title = docInfo.title,
          formattedDate = docInfo.formattedDate,
          timeToRead = docInfo.timeToRead,
          slug = docInfo.slug,
          cover = docInfo.cover,
          excerpt = docInfo.excerpt;
      var mobile = this.state.mobile; // const expand = mobile;

      /* eslint no-undef: "off" */

      var coverHeight = mobile ? 162 : 225;
      var ADMIN_EDIT_PAGE_URL = '/admin/#/collections/docs/entries/';
      var coverIsImg = cover.endsWith('.gif') || cover.endsWith('.jpeg') || cover.endsWith('.jpg') || cover.endsWith('.png');
      return _react.default.createElement(_Card.default, {
        className: classes.card
      }, _react.default.createElement(_CardHeader.default, {
        avatar: _react.default.createElement(_Avatar.default, {
          "aria-label": "Recipe",
          className: classes.avatar
        }, title.substring(0, 1)),
        action: _react.default.createElement(_Tooltip.default, {
          title: "Edit this Doc",
          placement: "top"
        }, _react.default.createElement(_IconButton.default, {
          href: "".concat(ADMIN_EDIT_PAGE_URL).concat(slug),
          target: "_blank",
          "aria-label": "EditDoc"
        }, _ref)),
        title: title.toUpperCase(),
        subheader: "".concat(formattedDate, " - ").concat(timeToRead, " min read")
      }), coverIsImg && _react.default.createElement(_CardMedia.default, {
        className: classes.media,
        image: cover,
        title: title
      }), !coverIsImg && _react.default.createElement("div", {
        className: classes.coverTitle
      }, _react.default.createElement(_Typography.default, {
        component: "h2",
        variant: "h3",
        color: "secondary",
        gutterBottom: true
      }, cover)), _react.default.createElement(_CardContent.default, null, _react.default.createElement(_Typography.default, {
        component: "p"
      }, description)), _react.default.createElement(_CardActions.default, {
        className: classes.actions,
        disableActionSpacing: true
      }, _react.default.createElement(_gatsby.Link, {
        style: {
          textDecoration: 'none'
        },
        to: path
      }, _ref2), _react.default.createElement(_DocTags.default, {
        tags: tags
      }), _react.default.createElement(_IconButton.default, {
        className: (0, _classnames2.default)(classes.expand, (0, _defineProperty2.default)({}, classes.expandOpen, this.state.expanded)),
        onClick: this.handleExpandClick,
        "aria-expanded": this.state.expanded,
        "aria-label": "Show more"
      }, _ref3)), _react.default.createElement(_Collapse.default, {
        in: this.state.expanded,
        timeout: "auto",
        unmountOnExit: true
      }, _react.default.createElement(_CardContent.default, null, _react.default.createElement(_Typography.default, {
        component: "p"
      }, excerpt))));
    }
  }]);
  return DocSummary;
}(_react.Component);

var _default = (0, _styles.withStyles)(styles)(DocSummary);

exports.default = _default;